import type { BoardObjectV2 } from "@bezpart-board/shared";
import {
  clipboardMimeType,
  serializeClipboard,
  setInternalClipboard,
  writeBoardClipboardToSystem,
} from "../../editor/clipboard";

const PLAIN_PREFIX = "bezpart-board-objects:";

export type BoardCopyScene = {
  canEdit: boolean;
  getSelection: () => string[];
  findObject: (id: string) => BoardObjectV2 | null | undefined;
};

/** Объекты текущего выделения (для copy). */
export function getSelectedBoardObjects(scene: BoardCopyScene): BoardObjectV2[] {
  const ids = scene.getSelection();
  const objects: BoardObjectV2[] = [];
  for (const id of ids) {
    const obj = scene.findObject(id);
    if (obj) objects.push(JSON.parse(JSON.stringify(obj)) as BoardObjectV2);
  }
  return objects;
}

/**
 * Синхронная запись в clipboardData события copy — надёжнее async Clipboard API.
 * @returns true если обработали (preventDefault уже вызван).
 */
export function handleBoardClipboardCopy(
  ev: ClipboardEvent,
  scene: BoardCopyScene | null | undefined
): boolean {
  if (!scene?.canEdit) return false;
  const objects = getSelectedBoardObjects(scene);
  if (!objects.length) return false;

  ev.preventDefault();
  setInternalClipboard(objects);

  const json = serializeClipboard(objects);
  const plain = PLAIN_PREFIX + json;
  try {
    ev.clipboardData?.setData("text/plain", plain);
  } catch {
    /* ignore */
  }
  try {
    ev.clipboardData?.setData(clipboardMimeType(), json);
  } catch {
    /* custom MIME может быть недоступен */
  }

  // Дубль через Clipboard API (на случай если setData обрежется) — без custom MIME.
  void writeBoardClipboardToSystem(objects);
  return true;
}
